export const isNullOrEmpty = str => {
    return str === null || str.match(/^ *$/) !== null;
};
